<template>
    <div class="relative">
        <flickity ref="flickity" :options="flickityOptions" @init="flickityReady">
            <slot></slot>
        </flickity>
        <div class="container mx-auto relative" v-if="numberOfSlide > 1">
            <div class="flex items-center justify-between absolute pin-b pin-r p-6 w-full md:pb-12 md:w-auto">
                <button @click="previous()" class="btn btn-icon btn-tertiary"><sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-90 align-middle" /></button>
                <ul class="list-reset flex md:flex-order-1 md:ml-6">
                    <li v-for="s in numberOfSlide" :key="s" @click="select(s-1)" :class="{ 'bg-white' : s-1 == selectedIndex }" class="border border-white rounded-full bg-transparent w-4 h-4 trans mx-1 hover:bg-green hover:border-green focus:bg-green focus:border-green cursor-pointer"></li>
                </ul>
                <button @click="next()" class="btn btn-icon btn-tertiary md:ml-2"><sprite sprite-id="arrow" class="fill-transparent stroke-current rotate-270 align-middle" /></button> 
            </div>
        </div>
    </div>
</template>

<script>
import Flickity from './_Flickity.vue';
import Sprite from './_Sprite.vue';

export default {
    name: 'MastheadCarousel',
    components:{
        Flickity,
        Sprite
    },
    data () {
        let self = this;
        return {
            flickityOptions: {
                wrapAround: true,
                adaptiveHeight: true,
                prevNextButtons: false,
                pageDots: false,
                autoPlay: 7000,
                pauseAutoPlayOnHover: false,
                selectedAttraction: 0.01,
                friction: 0.25

            },
            numberOfSlide: 0,
            selectedIndex: 0
        }
    },
    mounted () {
        let self = this;
        let onSelectChange = () => {
            self.selectedIndex = self.$refs.flickity.selectedIndex();
        }
        self.$refs.flickity.on('select', onSelectChange);
        self.$once('hook:beforeDestroy', () => {
            self.$refs.flickity.off('select', onSelectChange);
        })
    },
    methods: {
        flickityReady() {
            this.numberOfSlide = this.$refs.flickity.slides().length;
        },
        next() {
            this.$refs.flickity.next();
            this.$refs.flickity.stopPlayer();
            this.$refs.flickity.playPlayer();
        },
        previous() {
            this.$refs.flickity.previous();
            this.$refs.flickity.stopPlayer();
            this.$refs.flickity.playPlayer();
        },
        select(s) {
            this.$refs.flickity.select(s);
            this.$refs.flickity.stopPlayer();
            this.$refs.flickity.playPlayer();
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/js/components/MastheadCarousel.vue